import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { getGeneralState, getRoleState } from '@/http/api'

export const useAppStateStore = defineStore('appState', () => {
  const state = ref(null)

  const isCompetitionActive = computed(() => state.value?.isCompetitionActive ?? null)
  const canRegisterSchool = computed(() => state.value?.canRegisterSchool ?? null)
  const rules           = computed(() => state.value?.rules ?? null)
  const steps           = computed(() => state.value?.steps ?? null)

  async function fetchGeneralState() {
    const { data } = await getGeneralState()
    state.value = data
  }

  async function fetchRoleState() {
    const { data } = await getRoleState()
    state.value = data
  }

  return { isCompetitionActive, canRegisterSchool, rules, steps, fetchGeneralState, fetchRoleState }
})
